const Vue = window.Vue;
const VueRouter = require('vue-router').default;

Vue.component('activity-app', require('./components/pages/activity/Index.vue').default)

if ($('#activity-app').length) { // for deposit-app
    const app = new Vue().$mount('#activity-app');
}